import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Link } from "@material-ui/icons";
import { Model } from "@ofqual/portal-core/core/types";
import React from "react";
import { userRendererStyles } from "./useRendererStyles";

type CaseTileProps = {
  tile: Model;
  navigate?: (filterUrl: string) => void;
};

export const CaseAllocationTile: React.FC<CaseTileProps> = ({
  tile,
  navigate,
}) => {
  const classes = userRendererStyles();

  const getColorClass = (
    lowerLimit: number,
    upperLimit: number,
    value: number
  ) => {
    if (value <= lowerLimit) {
      return classes.green;
    }
    if (value > lowerLimit && value < upperLimit) {
      return classes.amber;
    }
    if (value >= upperLimit) {
      return classes.red;
    }
  };

  const getChips = (groups: Model, type: string) => {
    const group = groups.find((x: any) => x.name === type);
    const findValue = (type: any) =>
      group ? group.data.find((x: Model) => x.title === type)?.value || 0 : 0;
    return (
      <>
        <Grid item xs={3}>
          <Chip
            label={findValue("OPEN")}
            size="small"
            className={`${classes.chip} ${getColorClass(
              tile.lowerLimit || 0,
              tile.upperLimit || 10,
              findValue("OPEN")
            )}`}
          ></Chip>
        </Grid>
        <Grid item xs={3}>
          <Chip
            label={findValue("ABOUT_TO_BREACH")}
            size="small"
            className={`${classes.chip} ${getColorClass(
              tile.lowerLimit || 0,
              tile.upperLimit || 10,
              findValue("ABOUT_TO_BREACH")
            )}`}
          ></Chip>
        </Grid>
        <Grid item xs={3}>
          <Chip
            label={findValue("BREACHED")}
            size="small"
            className={`${classes.chip} ${getColorClass(
              tile.lowerLimit || 0,
              tile.upperLimit || 10,
              findValue("BREACHED")
            )}`}
          ></Chip>
        </Grid>
      </>
    );
  };

  //const createdByName = useFieldLookup(usersService, tile.title);

  return (
    <Grid item xs={12}>
      <Card className={classes.root}>
        <CardHeader
          action={
            <Tooltip title={`View list of cases for ${tile.title}`}>
              <IconButton onClick={() => navigate && navigate(tile.filterUrl)}>
                <Link style={{ fill: "currentcolor" }} />
              </IconButton>
            </Tooltip>
          }
          avatar={<Avatar />}
          title={
            <Typography variant="body1" className={classes.cardHeading}>
              {tile.name}
            </Typography>
          }
          className={classes.header}
        />
        <Divider />
        <CardContent className={classes.cardContent}>
          <Grid container spacing={2}>
            <Grid item xs={3}></Grid>
            <Grid item xs={3}>
              <Typography variant="caption" className={classes.countCaption}>
                Open
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption" className={classes.countCaption}>
                About to breach
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption" className={classes.countCaption}>
                Breached
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption" className={classes.countCaption}>
                Cases
              </Typography>
            </Grid>
            {getChips(tile.groups, "generic")}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
  // ) : (
  //   <Grid item xs={12}>
  //     <Skeleton variant="text" height={60} />
  //     <Skeleton variant="text" height={60} />
  //     <Skeleton variant="text" height={60} />
  //   </Grid>
  // );
};
